export enum ValidationSeverity {
  ERROR = 'error',
  WARNING = 'warning',
}
